import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

const MAX_CHARS = 5000;

/**
 * AppDescriptionTab — Editable app description.
 * Surfaces the app_description field that was set during onboarding.
 */
export default function AppDescriptionTab({ schema, onChange, readOnly }) {
  const description = schema?.app_description || '';
  const charCount = description.length;

  return (
    <div className="space-y-4 pt-4">
      <div className="space-y-1.5">
        <Label htmlFor="app-description" className="text-sm font-medium">
          App Description
        </Label>
        <p className="text-xs text-muted-foreground">
          Describe what your app does, who it's for, and what kind of knowledge it manages.
          This drives how the curiosity engine frames questions for your users.
        </p>
      </div>

      <Textarea
        id="app-description"
        value={description}
        onChange={(e) => {
          const val = e.target.value;
          if (val.length <= MAX_CHARS) {
            onChange?.({ ...schema, app_description: val });
          }
        }}
        placeholder="e.g. MainCharacter.ai helps fiction authors build deep, psychologically grounded characters by tracking values, beliefs, relationships, and narrative tensions across their stories..."
        rows={8}
        disabled={readOnly}
        className="resize-y min-h-[120px] text-sm"
      />

      <div className="flex justify-end">
        <span className={`text-xs ${charCount > MAX_CHARS * 0.9 ? 'text-yellow-500' : 'text-muted-foreground'}`}>
          {charCount.toLocaleString()} / {MAX_CHARS.toLocaleString()}
        </span>
      </div>
    </div>
  );
}
